export default "__VITE_ASSET__b26d9975__"